module.exports = __webpack_public_path__ + "img/top-2-1.8a28b0b5.jpg";